import pdfobject from "pdfobject"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { showToastMessage } from "../../../stateManagement/reducers"
import { Loader } from "../../loaders/Loader"
import { fetchDocumentView } from "../../../api/documentsApi"

export default function DocumentViewerPDF() {
    const dispatch = useDispatch()
    const { documentId, landRightDocumentId }: any = useParams()
    const [documentIsLoading, setDocumentIsLoading] = useState<boolean>(true)
    const pdfViewerDivId = "document-pdf-viewer-div"

    async function getDocumentFile() {
        setDocumentIsLoading(true)
        const file = await fetchDocumentView(documentId || landRightDocumentId)
        if (file) {
            if (file instanceof Blob) {
                const fileURL = URL.createObjectURL(file)
                pdfobject.embed(fileURL, `#${pdfViewerDivId}`);
            } else {
                dispatch(showToastMessage({ messageText: "Возникла ошибка при загрузке документа для просмотра", messageType: "error" }))
            }
        }
        setDocumentIsLoading(false)
    }

    useEffect(() => {
        getDocumentFile()
    }, [documentId, landRightDocumentId])

    return (
        <>
            {documentIsLoading && <Loader />}
            <div id={pdfViewerDivId} />
        </>
    )
}
